import { BaseHttpAdapter } from '~/services/adapters/base-http.adapter';
import { IUserResponse } from '~/types/server.types';
import { ILoginRequestData } from '~/types/server.types';
import { getForterToken } from '~/utils/client-experience.utils';
import { convertMtaCookieToHeader } from '~/utils/dom.utils';

export abstract class BaseSessionAdapter extends BaseHttpAdapter {
    logout({
        email,
        headers
    }: {
        email: string;
        headers?: Record<string, any>;
    }) {
        return this.apiService.apiRequest({
            method: 'delete',
            url: `/api/v2/users/tokens`,
            headers,
            data: { email }
        });
    }

    _loginReactFirst({
        data,
        headers
    }: {
        data: ILoginRequestData;
        headers?: Record<string, any>;
    }) {
        return this.apiService.apiRequest<IUserResponse>({
            method: 'post',
            url: `/api/v2/users/tokens`,
            data,
            headers,
            networkLabel: 'login'
        });
    }

    async loginClientPortalReactFirst({
        email,
        password,
        source,
        sourceData,
        trust_device,
        g_recaptcha_response_v3,
        fingerprint
    }: Omit<
        ILoginRequestData,
        'f_token' | 'company_id' | 'g-recaptcha-response-v3'
    > & {
        g_recaptcha_response_v3?: string;
    }) {
        const company_id = window.clientPortalConfiguration?.company_id;
        const f_token = getForterToken();

        const data = {
            password,
            trust_device: trust_device ?? true,
            source,
            sourceData,
            company_id,
            f_token,
            email,
            'g-recaptcha-response-v3': g_recaptcha_response_v3 ?? null,
            fingerprint
        };

        const headers = convertMtaCookieToHeader();

        return this._loginReactFirst({ data, headers });
    }
}
